import { PropTypes } from "prop-types"

import Translate from "../Translate"
import MediaChecker from "../MediaChecker"
import mediaBreakpoints from "../MediaChecker/mediaBreakpoints"

import Button from "../Button"

export function MapButton({ onClick }) {
  return (
    <MediaChecker size={mediaBreakpoints.TABLET.MAX}>
      {isSmallDevice => {
        const buttonLabel = isSmallDevice
          ? "mapShoppingFixedButtonLabel"
          : "mapShoppingInlineButtonLabel"

        return (
          <div className="oj-map-button">
            <Button onClick={onClick}>
              <Translate id={buttonLabel} />
            </Button>
          </div>
        )
      }}
    </MediaChecker>
  )
}

MapButton.propTypes = {
  onClick: PropTypes.func
}

export default MapButton
